import { AuthRepositoryImpl } from "@/data/AuthRepositoryImpl";
import { TweetRepositoryImpl } from "@/data/TweetRepositoryImpl";
import { UserRepositoryImpl } from "@/data/UserRepositoryImpl";
import { getFirebaseAuth, getFirestore } from "@/data/Firebase";
const auth = getFirebaseAuth();
const db = getFirestore();
const authRepository = new AuthRepositoryImpl(auth);
export function provideAuthRepository() {
    return authRepository;
}
const tweetRepository = new TweetRepositoryImpl(db);
export function provideTweetRepository() {
    return tweetRepository;
}
const userRepository = new UserRepositoryImpl(db);
export function provideUserRepository() {
    return userRepository;
}
